import { render, staticRenderFns } from "./shop-goods-list.vue?vue&type=template&id=2fe70f50&scoped=true"
import script from "./shop-goods-list.vue?vue&type=script&lang=js"
export * from "./shop-goods-list.vue?vue&type=script&lang=js"
import style0 from "./shop-goods-list.vue?vue&type=style&index=0&id=2fe70f50&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe70f50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\mrzhj\\Desktop\\ff\\frontent\\takeout\\www\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fe70f50')) {
      api.createRecord('2fe70f50', component.options)
    } else {
      api.reload('2fe70f50', component.options)
    }
    module.hot.accept("./shop-goods-list.vue?vue&type=template&id=2fe70f50&scoped=true", function () {
      api.rerender('2fe70f50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shop-details/shop-goods-list.vue"
export default component.exports